import CloseIcon from '@mui/icons-material/Close';

import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import FormHelperText from '@zenbusiness/zui/FormHelperText';
import FormLabel from '@zenbusiness/zui/FormLabel';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const FieldLabel = superstyled({
  name: 'TagInputField',
  slot: 'FieldLabel',
  tag: FormLabel,
  styles: ({ theme }) => ({
    marginBlockEnd: theme.spacing(1),
    '&.Mui-error': {
      color: theme.palette.primary.main
    },
    '& .MuiFormLabel-asterisk': {
      display: 'none'
    }
  })
});

export const FieldDescription = superstyled({
  name: 'TagInputField',
  slot: 'FieldDescription',
  tag: Text,
  propsAdded: {
    size: 'sm',
    color: 'secondary'
  },
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(2)
  })
});

export const InputContainer = superstyled({
  name: 'TagInputField',
  slot: 'InputContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'stretch'
  })
});

export const AddButton = superstyled({
  name: 'TagInputField',
  slot: 'AddButton',
  tag: Button,
  propsAdded: {
    variant: 'contained',
    color: 'success'
  },
  styles: ({ theme }) => ({
    minWidth: 'auto',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    whiteSpace: 'nowrap'
  })
});

export const TagsContainer = superstyled({
  name: 'TagInputField',
  slot: 'TagsContainer',
  tag: Box,
  styles: ({ theme }) => ({
    marginTop: theme.spacing(2)
  })
});

export const TagsList = superstyled({
  name: 'TagInputField',
  slot: 'TagsList',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1)
  })
});

export const Tag = superstyled({
  name: 'TagInputField',
  slot: 'Tag',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.grey.dark,
    borderRadius: theme.shape.rounded.md
  })
});

export const TagText = superstyled({
  name: 'TagInputField',
  slot: 'TagText',
  tag: Text,
  propsAdded: {
    size: 'sm'
  },
  styles: () => ({
    lineHeight: 1.4
  })
});

export const TagRemoveButton = superstyled({
  name: 'TagInputField',
  slot: 'TagRemoveButton',
  tag: 'button',
  styles: ({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.text.primary
    },
    '&:focus': {
      outline: `1px solid ${theme.palette.primary.main}`,
      borderRadius: theme.spacing(0.25)
    }
  })
});

export const RemoveIcon = superstyled({
  name: 'TagInputField',
  slot: 'RemoveIcon',
  tag: CloseIcon,
  styles: () => ({
    fontSize: '16px'
  })
});

export const FieldHelperText = superstyled({
  name: 'TagInputField',
  slot: 'FieldHelperText',
  tag: FormHelperText,
  styles: ({ theme }) => ({
    marginTop: theme.spacing(1)
  })
});
